import { render, staticRenderFns } from "./RiskScenarioHistory.vue?vue&type=template&id=292d5d59&"
import script from "./RiskScenarioHistory.vue?vue&type=script&lang=js&"
export * from "./RiskScenarioHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports